import { useMemo, useCallback, memo } from 'react';
import { ListCell } from '@cbhq/cds-web/cells';
import { VStack } from '@cbhq/cds-web/layout';
import { ActionType, ComponentType } from '@cbhq/client-analytics';
import { computeLocaleCode, DEFAULT_LOCALE, getLoggedOutConfig, getSupportedLocalesFromConfig } from '@cbhq/intl';
import globalNavLogEvent from '../../../utils/globalNavLogEvent.js';
import { useRouter } from '../../RouterContext.js';
import { GLOBAL_EDITION_CODE } from '../constants.js';
import { jsx } from 'react/jsx-runtime';
function LanguageSelector({
  countryCode,
  countries,
  localeInformation
}) {
  const supportedLocales = localeInformation.supportedLocales;
  const countryConfig = useMemo(() => {
    return countries.find(config => config.country_code === countryCode);
  }, [countryCode, countries]);
  const _useRouter = useRouter(),
    pathname = _useRouter.pathname;

  // Moved from the existing picker
  const handleChange = useCallback(selectedLanguage => {
    const langCode = selectedLanguage.tag;

    // If it is rest of the world, we use the language code as the locale code
    let localeCode = countryCode === GLOBAL_EDITION_CODE ? langCode : computeLocaleCode({
      countryCode,
      countryDefaultLocale: countryConfig?.default_locale || DEFAULT_LOCALE,
      isDefaultLocaleSinglePath: !!countryConfig?.is_default_locale_single_path,
      languageCode: langCode
    });

    // for EN + US combination, the locale from URL will be "/"
    // Hence, if the locale code is not present, we use the default locale
    // which is "en" which will be redirected to "/"
    //
    // TODO: @gokul.kathirvel We can update the `computeLocaleCode` logic
    // to return the default locale code for EN + US combination
    localeCode = localeCode || DEFAULT_LOCALE;
    globalNavLogEvent('logged_out_nav_language_selector_select', {
      action: ActionType.click,
      componentType: ComponentType.button,
      key: localeCode
    });
    const currentPath = pathname;
    let newPath = '';
    const config = getLoggedOutConfig();
    const supportedLocalesFromConfig = getSupportedLocalesFromConfig(config);
    const subfolderRegEx = new RegExp(
    // TODO: @gokul.kathirvel - once the supportedLocales is updated
    // we can remove `supportedLocalesFromConfig` from computation
    `^/(${[...supportedLocalesFromConfig, ...supportedLocales].join('|')})(/|$)`);
    if (currentPath === '/') {
      newPath = `/${localeCode}`; // Special case for the home page
    } else if (currentPath.match(subfolderRegEx)) {
      newPath = currentPath.replace(subfolderRegEx, `/${localeCode}/`);
    } else {
      newPath = `/${localeCode}${currentPath}`;
    }
    newPath = newPath.replace(/\/$/, ''); // Remove trailing slash, if exists

    // Forces a reload, forcing the client to go through the Node server's locale cookie setting process
    window.location.replace(newPath);
  }, [countryCode, countryConfig, pathname, supportedLocales]);
  return /*#__PURE__*/jsx(VStack, {
    width: "100%",
    spacing: 2,
    children: countryConfig?.supported_locales.map(language => {
      return /*#__PURE__*/jsx(ListCell, {
        outerSpacing: {
          spacing: 0
        },
        title: language.name
        // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop
        ,

        onPress: () => handleChange(language)
      }, language.tag);
    })
  });
}
const LanguageSelector$1 = /*#__PURE__*/memo(LanguageSelector);
export { LanguageSelector$1 as default };
//# sourceMappingURL=LanguageSelector.js.map
